import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4493f97c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "income-permission-badge"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("span", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode("含内购收入")], true)]);
}